<form class="filter-form" [formGroup]="filter_memberForm" >
    <h3 class="text-center">Filter</h3>
    <div class="form-group">
        <select class="form-control" formControlName="blood_group">
            <option hidden value="" disabled selected>બ્લડ ગ્રુપ </option>
            <option value="O-">O-</option>
            <option value="O+">O+</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
            <option value="No idea">No idea</option>
        </select>
    </div>
    <div class="row">
        <!-- <div class="col-md-4">
            <div class="form-group">
                <select class="form-control" formControlName="district_name" (change)="onDistrict_Id($event)">
                    <option hidden value="" disabled selected>જિલ્લો</option>
                    <option *ngFor="let district of dataDistrictList" [value]="district.district_id">{{district.district_name}}</option>
                </select>
            </div>
        </div>
        
        <div class="col-md-4">
            <div class="form-group">
                <select class="form-control" formControlName="subdivision_name" (change)="onSubdivision_Id($event)">
                    <option hidden value="" disabled selected >તાલુકો</option>
                    <option *ngFor="let subdivision of  subdivisionList"  [value]="subdivision.subdivision_id">{{subdivision.subdivision_name}}</option>
                </select>
            </div>
        </div>

        <div class="col-md-4">
            <div class="form-group">
                <select class="form-control" formControlName="village_name" >
                    <option hidden value="" disabled selected >ગામ</option>
                    <option *ngFor="let village of villageList"  [value]="village.village_id">{{village.village_name}}</option>
                </select>
            </div>
        </div> -->

        <div class="col-md-4">
            <div class="form-group">
                <select class="form-control" formControlName="city_name" >
                    <option hidden value="" disabled selected >શહેરો</option>
                    <option *ngFor="let city of cityList"  [value]="city.city_id">{{city.city_name}}</option>
                </select>
            </div>
        </div>
    </div>
    
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <button type="reset"  (click)="Cancel()" class="btn-common w-100 closeBtn">રદ કરો</button>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <button type="submit" class="btn-common w-100" (click)="submit()">મોકલવું</button>
            </div>
        </div>
    </div>
</form>